<template>
  <div>
    <div class="wechat-container" v-show="iswxhj">
        <div class="wechat-tip">
            <p>点击右上角按钮，然后在弹出的菜单中，点击在浏览器中打开，即可安装</p>
        </div>
        <div class="arrow-tip">
            <img src="../../../static/images/alert-arrow.png">
        </div>
    </div>
    <header class='demos-header'>
        <h1 class="demos-title">笔杆论文</h1>
        <p class='demos-sub-title'></p>
    </header>
    <div class="container">
        <div class="logo">
            <img src="../../../static/images/downLogo.png">
        </div>
        <div class="btn-container">
            <div class="box">
                <a href="javascript:void(0);" class="btn" @click="downloadApp">
                    <span>点击安装</span>
                </a>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default{
  data () {
    return {
      iswxhj: false,
      appUrl: {}
    }
  },
  methods: {
    isWx () {
      let ua = window.navigator.userAgent.toLowerCase()
      if (ua.indexOf('micromessenger') != -1 && !/(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent)) {
        this.iswxhj = true
      }
    },
    downloadApp () {
      let ua = window.navigator.userAgent.toLowerCase()
      if (/(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent)) {
        window.open(this.appUrl.iosUrl, '_blank')
      } else {
        if (ua.indexOf('micromessenger') != -1) {
          alert('点击右上角按钮，然后在弹出的菜单中，点击在浏览器中打开，即可安装', 'test-write-pc.bigan.net')
        } else {
          window.open(this.appUrl.androidUrl, '_blank')
        }
      }
    },
    // app下载地址
    getAppDownImg () {
      this.oauthapi.appdownUrl().then(res => {
        this.appUrl = res.data
      })
    }

  },
  created () {
    this.getAppDownImg()
    this.isWx()
  }
}
</script>

<style lang="scss" scoped="scoped">
.demos-header {
    padding: 20px 0;
    border-bottom: solid 1px #eee;
    text-align: center;
}

.demos-title {
    color: #202020;
    font-size: 22px;
    font-weight: 500;
    letter-spacing: 2px;
}

.container {
    padding: 40px 15px;
    padding-bottom: 10px;
}

.logo {
    text-align: center;
}

.logo>img {
    width: 120px;
    height: 120px;
    -webkit-border-radius: 24px;
    -moz-border-radius: 24px;
    border-radius: 24px;
    // border: 1px solid #ddd;
}

.btn-container {
    margin-top: 30px;
    text-align: center;
}

.btn {
    padding: 10px 80px;
    font-size: 18px;
    background: #4C91E2;
    background-image: linear-gradient(to right, #4C91E2 , #8CBAF6);
    cursor: pointer;
    position: relative;
    color: #ffffff;
    border-radius: 5px;
}

.btn>* {
    display: inline-block;
    vertical-align: middle;
}

.icon-download {
    width: 16px;
    height: 16px;
    background-size: 16px 16px;
}

.tip {
    text-align: center;
    margin-top: 20px;
}

.tip>span {
    display: inline;
    background-color: #5cb85c;
    font-size: 12px;
    font-weight: 400;
    padding: 3px 7px;
    color: #fff;
    border-radius: .25em;
}

.wechat-container {
    z-index: 99;
    width: 100%;
    background: rgb(52, 52, 52);
    margin-left: 0px;
    margin-right: 0px;
    padding-top: 30px;
    padding-bottom: 30px;
    box-shadow: rgba(22, 22, 23, 0.62) 0px -10px 16px inset;
}

.wechat-tip {
    padding-right: 50px;
    padding-left: 30px;
    position: relative;
    min-height: 1px;
    text-align: left;
}

.wechat-tip>p {
    font-size: 14px;
    color: #7f7e7e;
    margin: 0px;
}

.arrow-tip {
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;
    float: right!important;
}

.arrow-tip>img {
    width: 30px;
    margin-top: -68px;
    float: right!important;
    border: 0;
    vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/appdow/download.vue